import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  contactSelected(event) {
    const contactId = event.detail.id
    if (!contactId) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(`${this.urlValue}?contact_id=${contactId}`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "text/vnd.turbo-stream.html"
      }
    }).then(response => {
      if (response.ok) {
        window.location.reload()
      }
    })
  }
}
